/**
 * ADA swatch keyboard — sandbox-only
 * - Syncs .colorvalue on Color radio change
 * - Ensures Color radios are not display:none
 * - Syncs hidden Size mirror radios (for Dawn VariantRadios) from Size <select>
 * NO zoom / jquery.zoom / disableHoverZoom code.
 * Date: 2026-09-23
 */
(function () {
  function syncColorValue(input) {
    if (!input) return;
    var el = document.querySelector(".colorvalue");
    if (el) el.textContent = input.value || "";
  }

  function ensureNotDisplayNone(input) {
    if (!input) return;
    if (input.style && /display\s*:\s*none/i.test(input.style.cssText || "")) {
      input.style.removeProperty("display");
    }
  }

  function syncSizeMirrorsFromSelect() {
    var sel = document.querySelector(
      "select.variantselectpicker, select.select__select.variantselectpicker.size"
    );
    if (!sel) return;
    var val = sel.value;
    var mirrors = document.querySelectorAll('input[data-ada-size-mirror="1"]');
    if (!mirrors.length) {
      // Fallback: hidden Size radios inside non-color fieldsets
      mirrors = document.querySelectorAll(
        'variant-radios fieldset.product-form__input:not(.color) input[type="radio"]'
      );
    }
    mirrors.forEach(function (r) {
      r.checked = r.value === val;
    });
  }

  function bindSizeSelect() {
    var sel = document.querySelector(
      "select.variantselectpicker, select.select__select.variantselectpicker.size"
    );
    if (!sel || sel.dataset.adaSizeBound === "1") return;
    sel.dataset.adaSizeBound = "1";
    // Ensure never yanked from tab order by other scripts
    if (sel.tabIndex < 0) sel.tabIndex = 0;
    sel.removeAttribute("aria-hidden");
    sel.addEventListener("change", syncSizeMirrorsFromSelect);
    syncSizeMirrorsFromSelect();
  }

  function bindColorRadios() {
    var radios = document.querySelectorAll(
      'input[type="radio"][name="Color"], .colorflexitembox input[type="radio"]'
    );
    radios.forEach(function (r) {
      ensureNotDisplayNone(r);
      if (r.dataset.adaSwatchBound === "1") return;
      r.dataset.adaSwatchBound = "1";
      r.addEventListener("change", function () {
        syncColorValue(r);
      });
    });
    var checked = document.querySelector(
      'input[type="radio"][name="Color"]:checked, .colorflexitembox input[type="radio"]:checked'
    );
    if (checked) syncColorValue(checked);
  }

  function bind() {
    bindColorRadios();
    bindSizeSelect();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  document.addEventListener("shopify:section:load", bind);
})();

/*
 * FH colour swatches 2026-09-27: mark every colour that isn't available in the chosen size (class fh-na: faded tile
 * with a diagonal line, styled in ada-swatch-keyboard.css), instead of only after a shopper picks it. Shoppers can
 * still pick it (the button then says Out of Stock / Not Available as before). Screen readers hear it too: the colour
 * button's name becomes e.g. "Midnight, sold out in 4' x 6'" or "Indigo, not available in 2.5' x 8' Runner".
 * Rollback: delete this block.
 */
(function () {
  function variants() {
    var el = document.querySelector('.productvariantjson');
    if (!el) return null;
    try {
      var list = JSON.parse(el.textContent || '[]');
      return Array.isArray(list) ? list : null;
    } catch (e) {
      return null;
    }
  }

  function options(v) {
    return v.options || [v.option1, v.option2, v.option3];
  }

  function update() {
    var list = variants();
    if (!list) return;
    var sel = document.querySelector('select.variantselectpicker');
    var size = sel ? sel.value : '';
    var radios = document.querySelectorAll('.colorflexitembox input[type="radio"][name="Color"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var match = null;
      for (var k = 0; k < list.length; k++) {
        var o = options(list[k]);
        if (o.indexOf(r.value) !== -1 && (!size || o.indexOf(size) !== -1)) {
          match = list[k];
          break;
        }
      }
      var na = !match || !match.available;
      var label = r.nextElementSibling;
      if (label && label.classList) label.classList.toggle('fh-na', na);
      var name = r.value;
      if (na) name += (match ? ', sold out' : ', not available') + (size ? ' in ' + size : '');
      if (r.getAttribute('aria-label') !== name) r.setAttribute('aria-label', name);
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('select.variantselectpicker, input[name="Color"]')) setTimeout(update, 0);
  }, true);
  if (window.jQuery) {
    jQuery(document).on('change.fhswatch', 'select.variantselectpicker', function () { setTimeout(update, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('shopify:section:load', update);
})();
